import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { facilityService } from 'src/app/services/facility.service';

@Component({
  standalone: false,
  selector: 'app-cancel-facility-booking',
  templateUrl: './cancel-facility-booking.component.html',
  styleUrls: ['./cancel-facility-booking.component.scss'],
})
export class CancelFacilityBookingComponent implements OnInit {
  @Input() id: string;
  @Input() facilityId: string;

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private facilityService: facilityService
  ) {
    this.myForm = this.formBuilder.group({
      DeleteRemarks: ['', [Validators.maxLength(500), Validators.required]],
      deletedBy: '',
      vegetationId: ''
    });
  }

  ngOnInit(): void { }

  cancelBooking() {
    const payload = {
      facilityCalendarId: this.facilityId
    };
    this.facilityService.cancelBlockedFacility(payload).subscribe((res) => {
      console.log(res);
      location.reload();
    });
  }
}
